import dayjs, { Dayjs } from "dayjs";
import { useStringQueryParamState } from "./useStringQueryParamState";
import { useCallback, useMemo } from "react";
import utc from "dayjs/plugin/utc";
import timezonePlugin from "dayjs/plugin/timezone";
import isToday from "dayjs/plugin/isToday";
import { parseLocalDateTime } from "src/utils/parseLocalDateTime";

dayjs.extend(utc);
dayjs.extend(timezonePlugin);
dayjs.extend(isToday);

export const parseDateParam = (value: string, timezone?: string): Dayjs =>
  timezone
    ? parseLocalDateTime(value, timezone).tz(timezone)
    : dayjs(value).startOf("day");

export const useDayjsDateStringParamState = (
  paramName: string,
  defaultValue: Dayjs,
  timezone?: string
): [Dayjs, (date: Dayjs) => void] => {
  const [value, setValue] = useStringQueryParamState(
    paramName,
    defaultValue.format("YYYY-MM-DD")
  );
  const date = useMemo(
    () => parseDateParam(value, timezone),
    [value, timezone]
  );
  const setDate = useCallback(
    (date: Dayjs) => {
      setValue(date.format("YYYY-MM-DD"));
    },
    [setValue]
  );
  return [date, setDate];
};
